<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 26 26"
    height="24"
    width="24"
  >
    <g transform="translate(1, 1)">
      <desc>Created with Sketch.</desc>
      <g
        fill-rule="evenodd"
        fill="none"
        stroke-width="1"
        stroke="none"
        id="icon/popular/trash-copy-3_1606105136191"
      >
        <path v-if="disabledColor" fill="#9FA5AC" id="Combined-Shape_1606105574265" d="M15.5,2 C15.7761424,2 16,2.22385763 16,2.5 L16,2.5 L15.9999454,6 L21.2916034,6 C21.5677458,6 21.7916034,6.22385763 21.7916034,6.5 C21.7916034,6.74545989 21.6147282,6.94960837 21.381479,6.99194433 L21.2916034,7 L18.9949454,7 L17.4973724,21.5511927 C17.4740448,21.7778367 17.3017285,21.9561712 17.0837012,21.993003 L17,22 L7,22 C6.74356452,22 6.5287004,21.8059997 6.50259718,21.5508963 L6.50259718,21.5508963 L5.01294536,7 L2.75494536,7 C2.47880298,7 2.25494536,6.77614237 2.25494536,6.5 C2.25494536,6.25454011 2.43182052,6.05039163 2.66506973,6.00805567 L2.75494536,6 L7.99994536,6 L8,2.5 C8,2.25454011 8.17687516,2.05039163 8.41012437,2.00805567 L8.5,2 Z M17.989,7 L6.018,7 L7.451,21 L16.548,21 L17.989,7 Z M15,3 L9,3 L9,6 L15,6 L15,3 Z" vector-effect="non-scaling-stroke" />
        <path v-else :fill="color" id="Combined-Shape_1606105136191" d="M15.5,2 C15.7761424,2 16,2.22385763 16,2.5 L16,2.5 L15.9999454,6 L21.2916034,6 C21.5677458,6 21.7916034,6.22385763 21.7916034,6.5 C21.7916034,6.74545989 21.6147282,6.94960837 21.381479,6.99194433 L21.2916034,7 L18.9949454,7 L17.4973724,21.5511927 C17.4740448,21.7778367 17.3017285,21.9561712 17.0837012,21.993003 L17,22 L7,22 C6.74356452,22 6.5287004,21.8059997 6.50259718,21.5508963 L6.50259718,21.5508963 L5.01294536,7 L2.75494536,7 C2.47880298,7 2.25494536,6.77614237 2.25494536,6.5 C2.25494536,6.25454011 2.43182052,6.05039163 2.66506973,6.00805567 L2.75494536,6 L7.99994536,6 L8,2.5 C8,2.25454011 8.17687516,2.05039163 8.41012437,2.00805567 L8.5,2 Z M17.989,7 L6.018,7 L7.451,21 L16.548,21 L17.989,7 Z M15,3 L9,3 L9,6 L15,6 L15,3 Z" vector-effect="non-scaling-stroke" />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
    name: 'TrashThinIcon',
    props: {
      disabledColor: {
        type: Boolean,
      },
      color: {
        type: String,
        default() {
          return '#256AB3';
        },
      },
    },
    computed: {
      colorHex() {
        return disabledColor ? '#9FA5AC' : '#256AB3';
      },
      colorRgb() {
        return disabledColor ? 'rgb(159,165,172)' : 'rgb(37, 106, 179)';
      },
    },
}
</script>